import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as globalAdd from '../../../connectionString';
import { PaBookAppointmentModal } from '../models/PaBookAppointment.model';
// import { Timestamp } from 'rxjs';
@Injectable()
export class PatientAppointmentService {

  constructor(private http: HttpClient) { }

  getPatientAppointments() {
    return this.http.get(globalAdd.Paneladdress + 'api/Patient/getAppointmentData');
  }

  generateRtfForPatient(notes) {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Home/generateRtfForPatient?notes='+ notes);
  }

//api/Patient/generateRtfForPatient
  getDoctorAppointments(doctorId: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/PA/Appointment/getDoctorEvents?doctorId='+doctorId);
  }

  schedulePatientHimself(doctorId: string, caseId: string, date: Date,startTime,endTime,saHospId,reason) {
    let PaBookModel:PaBookAppointmentModal = new PaBookAppointmentModal(
      doctorId,
      caseId,
      date,startTime,
      endTime,
      saHospId,
      reason
    );
    return this.http.post(globalAdd.Paneladdress + 'api/PA/Appointment/schedulePatientHimself', PaBookModel);

  }
}
